/*istanbul ignore next*/'use strict';

module.exports = {
  View: require('./view')
};


// WEBPACK FOOTER //
// ./~/mokit/lib/component/components/index.js